import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, InstagramIcon, MapPinIcon, InfoIcon } from 'lucide-react';
const FORM_ID = 'Vjrn3hbx1eKeZwcSeXGG';
const EMBED_SCRIPT_SRC = 'https://link.msgsndr.com/js/form_embed.js';
export function Contact() {
  useEffect(() => {
    if (document.querySelector(`script[src="${EMBED_SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = EMBED_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <section id="contact" className="py-24 bg-offwhite-100" data-id="element-154" data-mp="3owo0vrh50dq0">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-155" data-mp="3k4w6t6yrvpv4">
        <div className="grid lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] gap-12 lg:gap-16 items-start" data-id="element-156" data-mp="3k3bcnigde8xs">
          {/* Intro / direct contact */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-157" data-mp="ggks1ieagj03">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal-950 mb-5" data-id="element-158" data-mp="3b2hpqjh5yxuz">
              Have a Question?
            </h2>
            <p className="text-xl text-charcoal-800 leading-relaxed mb-6" data-id="element-159" data-mp="3f2rtrqlebe77">
              Not sure if this is the right fit, or just want to understand your
              options? Send me a message and I'll get back to you personally.
            </p>

            <div className="flex gap-4 rounded-2xl border border-amber-500/40 bg-amber-500/10 p-5 mb-10" data-id="element-160" data-mp="2s56ud9ynkokt">
              <InfoIcon size={22} className="text-amber-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-161" data-mp="2w71q7yxte9r7" />
              <p className="text-charcoal-800 leading-relaxed" data-id="element-162" data-mp="uedl1k1m1c8s">
                I'm happy to answer general questions about what you're dealing
                with and which care options might make sense.
              </p>
            </div>

            <h3 className="text-sm font-bold uppercase tracking-widest text-charcoal-500 mb-5" data-id="element-163" data-mp="1ybppyti7kzq6">
              Reach me directly
            </h3>
            <ul className="space-y-5" data-id="element-164" data-mp="1ucqlfa0e34z9">
              <li className="flex items-center gap-4" data-id="element-165" data-mp="1pcujdgb95nmc">
                <span className="bg-white w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border border-offwhite-200" data-id="element-166" data-mp="1pe5n5g4p6vdg">
                  <MailIcon size={20} className="text-amber-500" aria-hidden="true" data-id="element-167" data-mp="2i08b9003fszl" />
                </span>
                <a href="mailto:info@mcleanphysicaltherapy.com" className="text-charcoal-950 font-medium hover:text-amber-600 transition-colors break-all" data-id="element-168" data-mp="28b6vnaxgndm5">
                  info@mcleanphysicaltherapy.com
                </a>
              </li>
              <li className="flex items-center gap-4" data-id="element-169" data-mp="38b0iymroihkc">
                <span className="bg-white w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border border-offwhite-200" data-id="element-170" data-mp="38cbpuvgf85fo">
                  <InstagramIcon size={20} className="text-amber-500" aria-hidden="true" data-id="element-171" data-mp="3i858mwkqgv5w" />
                </span>
                <a href="https://www.instagram.com/dylanmclean.dpt/" target="_blank" rel="noopener noreferrer" className="text-charcoal-950 font-medium hover:text-amber-600 transition-colors" data-id="element-172" data-mp="3r9mku3v0scpb">
                  @dylanmclean.dpt
                </a>
              </li>
              <li className="flex items-center gap-4" data-id="element-173" data-mp="9sbom7r711k3">
                <span className="bg-white w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border border-offwhite-200" data-id="element-174" data-mp="duyn2riddkq9">
                  <MapPinIcon size={20} className="text-amber-500" aria-hidden="true" data-id="element-175" data-mp="iu2txbhtn6df" />
                </span>
                <span className="text-charcoal-800" data-id="element-176" data-mp="14fxwua9vf1m">
                  House of Gains Gym, Camarillo, CA
                  <span className="block text-sm text-charcoal-500" data-id="element-177" data-mp="ew48gt4vhvgh">
                    In-person visits by appointment only
                  </span>
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Embedded contact form */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white rounded-3xl border border-offwhite-200 shadow-lg p-4 md:p-6 overflow-hidden" data-id="element-178" data-mp="3ecizoburx2em">
            <iframe src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`} style={{
            width: '100%',
            height: 945,
            border: 'none',
            borderRadius: 8
          }} id={`inline-${FORM_ID}`} data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="CA - Contact Us Form" data-height="945" data-layout-iframe-id={`inline-${FORM_ID}`} data-form-id={FORM_ID} data-cookie-consent="true" data-cookie-consent-provider="auto" title="CA - Contact Us Form" data-id="element-179" data-mp="2klxwptpdykd6" />
          </motion.div>
        </div>
      </div>
    </section>;
}